<template>
  <div class="exhibitionList">
    <!-- <div class="content-title" v-if="lan == 'ch'">展会列表</div> -->
    <!-- <div class="content-title" v-else>Guest List</div> -->

    <!--搜索框-->
    <div class="search">
        <el-input v-model="jobFairName" style="width: 810px;" type="text" :placeholder="language.ticName"></el-input>
        <el-button type="primary" style="background: #0172fe;float: right;margin-right: 20px;" @click="search">搜索</el-button>
    </div>
    <el-col class="infoPub" style="width: 990px">
      <!-- <div class="total-data" v-if="userInfo.user_admin_state == 1">
        <span>{{ language.bbsForumAccount }}：{{ totalData.bbs_count }}</span>
        <span>{{ language.bbsForumLive }}：{{ totalData.play_count }}</span>
        <span>{{ language.bbsForumNowNum }}：{{ totalData.user_count }}</span>
      </div> -->
      <!-- 列表组件 -->
      <div class="content">
        <div class="kong" v-if="exhibitionList.length == 0" style="color: rgb(153, 153, 153); line-height: 100px;text-align: center;border-radius: 5px;">
          <span style="position: relative;top: 190px;letter-spacing: 1px;">还没有发布任何消息</span></div>
        <div>
          <div
            class="content-exhibitionList"
            v-for="(item, index) in exhibitionList"
            :key="index"
          >
            <div class="content-exhname" v-if="lan == 'ch'">
              {{ item.exh_name }}
            </div>
  <!--          <div class="content-exhname" v-else>{{ item.exh_name_en }}</div>-->

                <!--报名-->
<!--            <el-tooltip-->
<!--                class="item"-->
<!--                effect="dark"-->
<!--                v-if="item.user_type != 1"-->
<!--                :content="language.signUpTip"-->
<!--                style="margin-right: 20px;"-->
<!--                placement="top"-->
<!--            >-->
<!--              <div class="content-exhname-btn1" @click="signUpClick(item)">-->
<!--                {{ language.apply }}-->
<!--              </div>-->
<!--            </el-tooltip>-->
            <el-tooltip
              class="item"
              effect="dark"
              :content="language.GuestListnotes"
              placement="top"
            >
              <div class="content-exhname-btn" @click="goGuestList(item)">
                {{ userInfo.user_nature == 3 ? language.GuestList1 : language.GuestList2}}
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
      <!-- page -->
      <table-page
        :pageSize="pageSize"
        :layout="layout"
        :pageTotal="pageTotal"
        :currentPage="currentPage"
        @pageChange="pageChange"
      ></table-page>
    </el-col>
    <receiveMsg />
  </div>
</template>
<script>
import { language } from "../../../language/get";
import { ExhIndexType } from "../../../common/constant/exhibition";
import Cookie from "../../../common/cookie";
import searchBar from "../components/searchbar/searchbar";
import bbsList from "../components/bbslist/bbslist";
import tablePage from "../components/tablepage/tablepage";
import { isEmpty, isInternet } from "../../../common/validate";
import { roomUrl, windowsGoTo } from "../../../common/url";
import dialogPub from "../components/dialogpub/dialogpub";
const pubLanguage = language();
import downloadDialog from "../../../components/DownloadDialog/index";
import { Can_View_Exh_List } from "../../../api/exhibition";
import { mapGetters } from "vuex";
import { getLiveUrl } from "../../../api/forum";
import axios from "axios";
import receiveMsg from "../../../components/receiveMsg";
const initialization = {
  broadcast_id: "",
  broadcast_class_id: "",
  broadcast_name: "",
  broadcast_name_en: "",
  location: "",
  location_en: "",
  broadcast_name1: "",
  user_post: "",
  user_post_en: "",
  truename: "",
  truename_en: "",
  broadcast_class_name: "",
  tel: "",
  broadcast_introduce: "",
  broadcast_introduce_en: "",
  broadcast_logo: null,
  broadcast_applent_logo: null,
};
export default {
  components: {
    // searchBar,
    // bbsList,
    tablePage,
    receiveMsg,
    // downloadDialog,
    // dialogPub
  },
  computed: {
    ...mapGetters(["token", "userInfo"]),
  },
  data() {
    return {
      loading: "true",
      downloadShow: false,
      ExhIndexType,
      imgList: [],
      jobFairName:"", //招聘会名称
      language: language(),
      lan: Cookie.get("lang"),
      //page
      pageTotal: 0,
      pageSize: 4,
      currentPage: 1,
      layout: "prev, pager, next, jumper",

      exhibitionList: [],
    };
  },
  created() {
    this.getList();
  },
  mounted() {},
  methods: {
    signUpClick(item){
      if(this.userInfo.superioruser_id != 0){
        const height = document.body.clientHeight / 2;
        this.$message.error({message:"子账号不能进行报名", offset:height})
      }else{
        localStorage.setItem("buyBackUrl", location.href);
        let encodeData = window.btoa(window.encodeURIComponent("signUp=1&exhibitionId=" + item.exhibition_id));
        window.location.href = "ticketsRegister.html?" + encodeData;
      }

    },
    goGuestList(e) {
      this.$router.push({
        path: "/exhibitionList/guestList",
        query: {
          exhibition_id: e.exhibition_id,
          user_type: e.user_type
        },
      });
    },

    //分页
    pageChange(val) {
      this.currentPage = val;
      this.getList();
    },
    search() {
      this.getList();
    },
    getList() {
      let that = this;
      let data = {
        token: this.$store.state.user.token,
        user_id: this.userInfo.user_id,
        currentPage: this.currentPage,
        numberPage: this.pageSize,
        exh_name:this.jobFairName,
        user_nature:this.userInfo.user_nature
      };
      Can_View_Exh_List(data).then((res) => {
        this.exhibitionList = res.data || [];
        this.pageTotal = parseInt(res.datacount);
        console.log("totlal", this.pageTotal);
      });
    },
  },
};
</script>
<style scoped>
.search {
  width: 930px;
  padding: 30px 30px;
  background: #FFFFFF;
  margin-bottom: 10px;
  border-radius: 5px;
}
.kong {
  background: url("../../../assets/img/wu.png");
  background-size: 100% 100%;
  width: 993px;
  height: 382px;
}
.content {
  height: 490px;
   background: #ffffff;
}
.content-title {
  height: 20px;
  line-height: 20px;
  border-bottom: 1px solid #cccccc;
  /* padding: 20px; */
  padding: 10px 20px;
  font-size: 14px;
}
.content-exhibitionList {
  padding: 18px 0px;
  /* border-bottom: 1px solid #cccccc; */
  display: flex;
  width: 890px;
  background: transparent;
  margin: 0px 0  5px 50px;
  border-bottom: 1px solid #d8d8d8;
}
.content-exhname {
  flex: 1;
  font-size: 18px;
  /* line-height: 29px; */
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  /* justify-content: ; */
}
.content-exhname-btn {
  padding: 10px 20px;
  border: 1px solid #0071ff;
  color: #0071ff;
  border-radius: 5px;
  cursor: pointer;
  height: 20px;
}
.content-exhname-btn1 {
  padding: 10px 20px;
  border: 1px solid #107ce6;
  color: #FFFFFF;
  background: #0071fd;
  border-radius: 5px;
  cursor: pointer;
  height: 20px;
}
</style>
<style>
.bbsdialog .el-dialog {
  max-height: none;
}
.el-upload-list--picture-card .el-upload-list__item-status-label i {
  margin-top: 6px;
}
.bbsdialog .el-dialog__header {
  position: relative;
}
.bbsdialog .el-dialog__headerbtn {
  top: 4px;
}
.total-data {
  background: #ffffff;
  font-size: 18px;
  color: #434343;
  padding: 14px 10px;
}
.total-data > span {
  margin-right: 40px;
}
.dislogCon {
  text-align: center;
}
.img-formBtn {
  margin: 0 auto;
  text-align: center;
}
.img-down-formBtn {
  background: #ff9e00;
  width: 100px;
  height: 40px;
  color: #ffffff;
  border: none;
  font-size: 18px;
}
.img-camcale-formBtn {
  background: #cccccc;
  width: 100px;
  height: 40px;
  color: #ffffff;
  border: none;
  font-size: 18px;
}
.exhibitionList .infoPub .page {
  margin-left: 0px;
}
</style>
